import { render, staticRenderFns } from "./RegisterOTP.vue?vue&type=template&id=0ded7c94&scoped=true"
import script from "./RegisterOTP.vue?vue&type=script&lang=js"
export * from "./RegisterOTP.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/newLogin.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./RegisterOTP.vue?vue&type=style&index=2&id=0ded7c94&prod&lang=css"
import style3 from "./RegisterOTP.vue?vue&type=style&index=3&id=0ded7c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded7c94",
  null
  
)

export default component.exports